module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-2-4365f9aa32fdfc67ffa8c28bb26aa7af.png";